import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import * as CuentaContableService from 'services/cuentaContable.service'

import { OperacionesIngGasConstant } from 'constants/index'

import { ZariContext } from '_zari/context'

import { KeyEventUtil } from 'utils'


const IngresosGastosSelectFormGroup = ({
  iError,
  iTouched,
  values,
  setValues,
  updateStore,
  rowIndex
}) => {

  const __zariContext = React.useContext(ZariContext)


  const onChange = e => {
    values.tipoOperacion = e.target.value
    if (e.target.value === OperacionesIngGasConstant.INGRESOS) {
      if (values.cuentaContableVenta) {
        CuentaContableService.getCuentasContablesPresupuestoNuevo(values.cuentaContableVenta).then(({ data }) => {
          values.cuentaContable = data.value
          values.cuentaContableInfo = data.label
          values.cuentaContableTipoDocumento = data.tipoDocumento
          values.flagCentroCosto = data.flagCentroCosto
          values.esCuentaActivoFijo = data.esActivoFijo
          values.tipoSocio = data.tipoSocio
          values.moneda = data.moneda

          if (!data.value.startsWith('6') && !data.value.startsWith('9')) {
            values.tipoAfectacion = ''
          }

          setValues(values)

          setTimeout(() => {
            updateStore()
            KeyEventUtil.leaveOnKeyEvent(data.flagCentroCosto ? `select-det-centroCostoNivel1-${rowIndex}` : `input-det-importeDebe-${rowIndex}`)
          }, 200)
        }).catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
        })
      } else {
        __zariContext.snack('error', "El producto no tiene registrado cuenta contable para ventas")
      }
    } else if (e.target.value === OperacionesIngGasConstant.GASTOS) {
      if (values.cuentaContableCompra) {
        CuentaContableService.getCuentasContablesPresupuestoNuevo(values.cuentaContableCompra).then(({ data }) => {
          values.cuentaContable = data.value
          values.cuentaContableInfo = data.label
          values.cuentaContableTipoDocumento = data.tipoDocumento
          values.flagCentroCosto = data.flagCentroCosto
          values.esCuentaActivoFijo = data.esActivoFijo
          values.tipoSocio = data.tipoSocio
          values.moneda = data.moneda

          if (!data.value.startsWith('6') && !data.value.startsWith('9')) {
            values.tipoAfectacion = ''
          }

          setValues(values)

          setTimeout(() => {
            updateStore()
            KeyEventUtil.leaveOnKeyEvent(data.flagCentroCosto ? `select-det-centroCostoNivel1-${rowIndex}` : `input-det-importeDebe-${rowIndex}`)
          }, 200)
        }).catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
        })
      } else {
        __zariContext.snack('error', "El producto no tiene registrado cuenta contable para compras")
      }
    } else {
      setValues(values)

      setTimeout(() => {
        updateStore()
      }, 200)
    }
  }

  return (
    <Form.Group>
      <Col md={12}>
        <Field name='tipoOperacion'>
          {({ field }) => (
            <Form.Select
              {...field}
              id={`select-det-moneda-${rowIndex}`}
              isInvalid={iTouched && iError}
              onChange={onChange}
            >
              {OperacionesIngGasConstant.__array.map((x, k) =>
              (<option key={k} value={x.id} >
                {x.nombre}
              </option>)
              )}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group >
  )
}

export default React.memo(IngresosGastosSelectFormGroup)
